module.exports = function (fox) {
	var FormElementBase = require('./base')(fox);
	var ArrayProto = Array.prototype;

	return fox.extend({
		init: function () {
			var initResult = this.super('init', arguments);
			this.registerEventCallbacks();

			this.isMultiple = this.nodes[0].multiple;
			
			return initResult;
		},

		getValue: function () {
			if (!this.inDom()) return this.super('getValue', arguments);

			this.value = ArrayProto.reduce.call(this.nodes[0].options, function (acc, option) {
				if (option.selected) acc.push(option.value);

				return acc;
			}, []);

			if (!this.isMultiple) {
				this.value = this.value[0];
			}

			return this.super('getValue', arguments);
		},

		setValue: function (value) {
			if (!this.inDom()) return this.super('setValue', arguments);

			if (!this.isMultiple) {
				ArrayProto.some.call(this.nodes[0].options, function (option) {
					if (fox.isArray(value)) value = value[0];

					return option.value === value &&
						(option.selected = true) ||
						(option.selected = false);
				});
			} else {
				ArrayProto.reduce.call(this.nodes[0].options, function (acc, option) {
					if (!fox.isArray(value)) {
						value = [value];
					}
					if (fox.inArray(value, option.value)) {
						acc.push(value);
					}
					
					option.selected = fox.inArray(value, option.value);

					return acc;
				}, []);
			}

			return this.super('setValue', arguments);
		},

		reset: function () {
			ArrayProto.forEach.call(this.nodes[0].options, function (option) {
				option.selected = false;
			});

			this.value = this.isMultiple ? [] : this.getValue();

			return this;
		}
	}, FormElementBase, null, 'FormElementDomSelect');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/elements/dom/select.js
// module id = 94
// module chunks = 0